<div class="programs-grid">
	<div *ngFor="let program of programs" class="programs-grid__item">
		<span *ngIf="program.attr_is_featured > 0" class="tag font-5">Featured</span>
		<a class="programs-grid__item--image" routerLink="{{program.programDetailsUrl}}">
			<img *ngIf="program.getImage()" class="programs-grid__item__image" [src]="program.getImage().url" alt="Programs Image">
		</a>

		<div class="programs-grid__item--heading">
			<a routerLink="{{program.programDetailsUrl}}" class="link full-width">
				<span [innerHTML]="program.label | safeContent" class="programs-grid__item--label"></span>
			</a>
		</div>

		<div class="programs-grid__item--meta">
			<strong class="programs-grid__item--meta-type">{{ program.attr_program_type }}</strong>
			<div class="programs-grid__item--meta-dates" *ngIf="program.id > 1 && !isODProgram(program)">
				<span><strong>In Market Date:</strong> {{ program.in_market_start_at | dateFormat: 'DD-MMM-YYYY' }} - {{ program.in_market_end_at | dateFormat: 'DD-MMM-YYYY' }}</span>
				<span><strong>Ship Date:</strong> W/O, {{ program.ship_at | dateFormat: 'DD-MMM-YYYY' }}</span>
			</div>
		</div>

		<p class="programs-grid__item--description font-5" *ngIf="program.data && program.getContent()"
		   [innerHTML]="program.description  | truncate: 200 | safeContent">
		</p>

		<a class="link link-underline small uppercase" routerLink="{{program.programDetailsUrl}}">
			See More <i class="fal fa-angle-right"></i>
		</a>

		<div *ngIf="program.brandGuideUrl != ''" class="programs-grid__item--action">
			<a target="_blank" href="{{ program.brandGuideUrl }}">
				<i class="fal fa-file-pdf"></i>
				<span>
					Brand
					<br/>
					Activation Guide
				</span>
			</a>
			<a target="_blank" href="{{ program.brandGuideUrl }}">
				<span>Download</span>
				<i class="fal fa-arrow-to-bottom"></i>
			</a>
		</div>
	</div>
</div>
